import { AttachmentDocumentType } from "../../api/commercial/card-application/types";
import { PersonAttachment } from "../../api/commercial/generated-types";

export const attachmentTypeToDescription = (
  type: AttachmentDocumentType,
): string => {
  switch (type) {
    case AttachmentDocumentType.PASSPORT_ID_OR_DRIVER_LICENCE:
      return "CardholderConfirmation.document-passport-id-or-driver-licence-copy";
    case AttachmentDocumentType.AUTHENTICITY_PROOF:
      return "CardholderConfirmation.document-authenticity-proof";
    case AttachmentDocumentType.EMPLOYMENT_CONTRACT:
      return "CardholderConfirmation.document-employment-contact";
    case AttachmentDocumentType.PASSPORT_OR_ID:
      return "CardholderConfirmation.document-passport-or-id-copy";
    case AttachmentDocumentType.SWISS_ALIENS_CARD:
      return "CardholderConfirmation.document-swiss-aliens-card";
    case AttachmentDocumentType.COMMERCIAL_REGISTER_EXTRACT:
      return "CardholderConfirmation.document-commercial-register";
    case AttachmentDocumentType.FOUNDING_DOCUMENTS_OR_EQUIVALENT:
      return "CardholderConfirmation.document-founding-or-equivalent";
    case AttachmentDocumentType.ANNUAL_REPORT:
      return "CardholderConfirmation.document-annual-report";
  }
};

export const deduplicatedPersonAttachments = (list: PersonAttachment[]) => {
  return Array.from(
    new Set(list.map((a) => `${a.domain} ${a.firstName} ${a.lastName}`)),
  ).map((id) => {
    return list.find((a) => `${a.domain} ${a.firstName} ${a.lastName}` === id);
  });
};
